import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import MixNMatchSection from "./mixNMatchSection";
import SubGameTip from "./subGameTip";
import _ from "lodash";


function MixNMatch ({missionData, setShowMixNMatch, setShowSubgameTip, showSubgameTip, isMissionEnd})
{
  const { t } = useTranslation();

  const [finished, setFinished] = useState(false);
  const [segment1, setSegment1] = useState([]);
  const [segment2, setSegment2] = useState([]);
  const [segment3, setSegment3] = useState([]);

  const [showSliders, setShowSliders] = useState(false);
  const [currentLeft, setCurrentLeft] = useState(1);
  const [currentMid, setCurrentMid] = useState(1);
  const [currentRight, setCurrentRight] = useState(1);
  const [selectedRightAnswer, setSelectedRightAnswer] = useState(false);
  const [selectedWrongAnswer, setSelectedWrongAnswer] = useState(false);
  const [selectionChanged, setSelectionChanged] = useState(false);
  const [activeState, setActiveState] = useState(false);

  const players = useSelector((state) => state.game.players);
  const [mainQuestionPlayer, setMainQuestionPlayer] = useState(null);

  let mixNMatchRef = useRef(null);
  let helpRef = useRef(null);
  let bottomBorderRef = useRef(null);
  let missionOverviewRef = useRef(null);

  useEffect(()=> {
    let introDelayTimer
    if(missionData && missionData.mix_n_match_finished){
      setShowMixNMatch(false);
      setShowSubgameTip(true);
    }
    if(missionData) {
      introDelayTimer = setTimeout(() => {
        setShowSliders(true);
      }, 2000);
    }

    if(missionData && missionData.mix_n_match && missionData.other_tiles){
      let seg1 = [];
      let seg2 = [];
      let seg3 = [];

      let lastIndex = 0;
      missionData.other_tiles.forEach((tile, index) => {
        seg1.push({key: `${index}_0`, image: tile.image_1, match: 0});
        seg2.push({key: `${index}_1`, image: tile.image_2, match: 0});
        seg3.push({key: `${index}_2`, image: tile.image_3, match: 0});
        lastIndex = index;
      });

      lastIndex += 1;
      seg1.push({key: `${lastIndex}_0`, image: missionData.mix_n_match.image_1, match: 1});
      seg2.push({key: `${lastIndex}_1`, image: missionData.mix_n_match.image_2, match: 1});
      seg3.push({key: `${lastIndex}_2`, image: missionData.mix_n_match.image_3, match: 1});

      seg1 = _.shuffle(seg1);
      seg2 = _.shuffle(seg2);
      seg3 = _.shuffle(seg3);

      setSegment1(seg1);
      setSegment2(seg2);
      setSegment3(seg3);
    }
    return () => {
      clearTimeout(introDelayTimer);
    }
  }, []);

  useEffect(()=> {
    if(segment1.length > 0 && segment2.length > 0 && segment3.length > 0){
      if (activeState) {
        setSelectionChanged(true);
      }
    }
  }, [currentLeft, currentMid, currentRight]);

  useEffect(() => {
    if(missionData && players){
      const mainQPlayer = players.filter(player => player.secret === missionData.main_question_player);
      setMainQuestionPlayer(mainQPlayer[0]);
    }
  }, [missionData, players]);

  const getMainQuestionPlayerName = () => {
    return mainQuestionPlayer ? mainQuestionPlayer.name : '';
  }

  const handleConfirmAnswer = () => {
    const itemLeft = segment1[currentLeft === 3 ? 0 : currentLeft];
    const itemMid = segment2[currentMid === 3 ? 0 : currentMid];
    const itemRight = segment3[currentRight === 3 ? 0 : currentRight];
    if(itemLeft?.match === 1 && itemMid?.match === 1 && itemRight?.match === 1){
      setSelectedRightAnswer(true);
      setSelectionChanged(false);
      const rightAnswerTimeout = setTimeout(() => {
        setShowSubgameTip(true);
      },2000);
    } else {
      setSelectedWrongAnswer(true);
      const wrongAnswerTimeout = setTimeout(()=> {
        setSelectionChanged(false);
        setSelectedWrongAnswer(false);
      }, 800);
    }
  }

  return (
    
    <div className={`mix-n-match-wrapper ${isMissionEnd ? 'missionEnded' : ''}`}>
      <div className="mix-n-match">
        <div className="minigame-head"></div>
        <div className="strip-container">
          {showSliders &&
            <>
              <MixNMatchSection items={segment1} currentSelection={currentLeft} setCurrentSelection={setCurrentLeft} setActiveState={setActiveState} selectedRightAnswer={selectedRightAnswer} />
              <MixNMatchSection items={segment2} currentSelection={currentMid} setCurrentSelection={setCurrentMid} setActiveState={setActiveState} selectedRightAnswer={selectedRightAnswer} />
              <MixNMatchSection items={segment3} currentSelection={currentRight} setCurrentSelection={setCurrentRight} setActiveState={setActiveState} selectedRightAnswer={selectedRightAnswer} />
            </>
          }
        </div>
        <div className={`fxWrapper ${selectionChanged ? 'fadeToBackground' : ''}`}>
          <div className={`minigame-help frameSimple darkTheme ${selectedRightAnswer ? 'animateOut' : 'animateIn'}`}>
            <h2>Mix & Match</h2>
            <p className="bigger">Swipe omhoog of omlaag. Kijk in het boek en maak de goede combinatie.{/*{ t("student.mix_n_match.help_text", [getMainQuestionPlayerName()])}*/}</p>
          </div>
        </div>
      </div>
      {selectedRightAnswer &&
        <div className="finish-wrapper">
          <div className="finish speechBalloonVertical auto-hide">
            <h3>Yeeeee!</h3>
            <p>Je hebt de goede combinatie gevonden.</p>
          </div>
        </div>
      }
      <div className={`hint-background ${showSubgameTip ? 'unlocked' : ''}`}>
        {showSubgameTip && <div className="tip-container">
          <SubGameTip missionData={missionData} setShowSubgameTip={setShowSubgameTip} />
        </div>}
        <div className="panel-wrapper panel-top">
          <div className="background-panel"><div className="lock-band top"></div></div>
        </div>
        <div className="panel-wrapper panel-bottom">
          <div className="background-panel"><div className="lock-band bottom"></div></div>
        </div>
        <div className="lock-container">
          <div className={`lock ${showSubgameTip ? 'unlocked' : ''}`}></div>
        </div>
      </div>
      {selectionChanged &&
        <div className="navigationWrapper">
          <div className="navigationDrawer variant4 enableInAnimation">
            <button className={`submitButton enableInAnimation ${selectedWrongAnswer ? 'errorShake' : ''}`} onClick={() => { handleConfirmAnswer(); }}>
              <span className="caption">Kies!</span>
            </button>
          </div>
        </div>
      }
    </div>
  );
}

/*

<div className="mix-n-match-wrapper">
      <div className="mix-n-match" ref={ e => { mixNMatchRef = e }}>
        <div className="title">
          <h3>{t("student.mix_n_match.title")}</h3>
        </div>
        <div className={`mix-n-match-orange-bar ${selectedCorrectAnswer ? 'green': ''}`}></div>
        <div className="match-wrapper">
          <MixNMatchSection items={segment1} currentIndex={currentLeft} setCurrentIndex={setCurrentLeft} selectedCorrectAnswer={selectedCorrectAnswer} />
          <MixNMatchSection items={segment2} currentIndex={currentMid} setCurrentIndex={setCurrentMid} selectedCorrectAnswer={selectedCorrectAnswer} />
          <MixNMatchSection items={segment3} currentIndex={currentRight} setCurrentIndex={setCurrentRight} selectedCorrectAnswer={selectedCorrectAnswer} />
        </div>
        
        <div className="help" ref={ e => { helpRef = e }}>
          <p>{ t("student.mix_n_match.help_text", [getMainQuestionPlayerName()])}</p>
        </div>
        <div className="bottom-border" ref={ e => { bottomBorderRef = e}}></div>
        {finished && 
          <div className="finished-overlay">
              <div className="match-message">
                <h3>{ t("student.mix_n_match.match_sucess_title") }</h3>
                <div className="match-image">
                  {missionData && missionData.mix_n_match && missionData.mix_n_match.reference_image && <img src={missionData.mix_n_match.reference_image} width={150} />}
                </div>
              </div>
              <div className="bottom-border">
              </div>
          </div>
        }  
      </div>
    </div>


*/

export default MixNMatch;